export const ACCORDION_BORDER_RADIUS = '16px';
